import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Card, CardContent } from '@/components/ui/card'
import { BookOpen, X } from 'lucide-react'
import { presetTemplates, extractVariables, PresetTemplate } from '@/data/presetTemplates'

interface PresetTemplateModalProps {
  isOpen: boolean
  onClose: () => void
  onSelect: (template: PresetTemplate) => void
  selectedType?: string
}

export default function PresetTemplateModal({ 
  isOpen, 
  onClose, 
  onSelect, 
  selectedType 
}: PresetTemplateModalProps) {
  const templates = selectedType ? presetTemplates[selectedType] || [] : []

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle className="flex items-center">
              <BookOpen className="h-5 w-5 mr-2" />
              常用模板推荐
            </DialogTitle>
            <Button variant="ghost" size="sm" onClick={onClose}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </DialogHeader>
        
        <div className="flex-1 overflow-y-auto pr-2">
          {templates.length > 0 ? (
            <div className="grid gap-4">
              {templates.map((template) => (
                <Card 
                  key={template.id} 
                  className="cursor-pointer hover:shadow-md transition-shadow"
                  onClick={() => {
                    onSelect(template)
                    onClose()
                  }}
                >
                  <CardContent className="p-4">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <h3 className="font-medium text-gray-900 mb-1">{template.name}</h3>
                        <p className="text-sm text-gray-600">{template.description}</p>
                      </div>
                      <Badge variant="outline" className="text-xs">
                        {extractVariables(template.content).length}个变量
                      </Badge>
                    </div>
                    
                    <div className="bg-gray-50 p-3 rounded-md mb-3">
                      <p className="text-sm text-gray-700 font-mono">{template.content}</p>
                    </div>
                    
                    <div className="flex items-center justify-between">
                      <div className="flex gap-2">
                        {extractVariables(template.content).map((variable) => (
                          <Badge key={variable} variant="secondary" className="text-xs">
                            {variable}
                          </Badge>
                        ))}
                      </div>
                      <Button size="sm" variant="outline">
                        使用此模板
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <BookOpen className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">请先选择模板类型</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
